import { useAlgoTileId } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoNDFFixingSource } from '@/store/orders/algoOrders/selectors.ts';

const AlgoNDFFixingSource = () => {
  const tileId = useAlgoTileId();
  const ndfSourceFixing = useAppSelector((state) => selectAlgoNDFFixingSource(state, tileId));

  return (
    <OrderRow labelId="order.fields.fixingSource">
      <span className="fs-12">{ndfSourceFixing} </span>
    </OrderRow>
  );
};

export default AlgoNDFFixingSource;
